<div class="row g-0 bn-auth__container">
  <div
    class="bn-auth__side"
    [ngClass]="{
      'col-lg-6': sliderConfig?.length,
      'col-12': !sliderConfig?.length,
    }">
    <div class="bn-auth__form">
      <div class="text-center">
        <img
          alt="Bunny.net logo"
          class="bn-auth__logo"
          src="/assets/images/logo-bunnynet-dark-blue.svg" />
        <div class="bn-auth__title">Verify Your Login</div>
        <p class="bn-auth__description">Enter your two factor authentication code below.</p>
      </div>
      <form
        data-e2e="AuthPagesTwoFactorAuthForm"
        [formGroup]="form">
        <bn-web-ui-two-factor-code
          class="bn-auth-2fa__code"
          formControlName="twoFactorCode"
          [autofocus]="true"
          [loading]="isLoading.submit" />
        @if (isError) {
          <bn-web-ui-alert
            alertType="danger"
            class="text-start mt-4"
            headerIcon="circle-exclamation"
            heading="Two factor authentication failed."
            [showIcon]="true" />
        }
        <p class="text-center mt-6">
          <a
            class="btn btn-link"
            [routerLink]="['/', authRoutes.Auth, authRoutes.Login]"
            >Back to Log In</a
          >
        </p>
      </form>
    </div>
  </div>
  @if (sliderConfig?.length) {
    <div class="col-lg-6 d-none d-lg-flex bn-auth__side bn-auth__side--right">
      <bn-auth-content-slider
        [centered]="true"
        [items]="sliderConfig"
        [loading]="isLoading.initial" />
    </div>
  }
</div>
